module.exports = __webpack_public_path__ + "static/img/egg_g_19.40b7a4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_19.png
// module id = v+sH
// module chunks = 1